import { render, staticRenderFns } from "./groupon_propose_entry.vue?vue&type=template&id=6f610b7a&scoped=true&"
import script from "./groupon_propose_entry.vue?vue&type=script&lang=js&"
export * from "./groupon_propose_entry.vue?vue&type=script&lang=js&"
import style0 from "./groupon_propose_entry.vue?vue&type=style&index=0&id=6f610b7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f610b7a",
  null
  
)

export default component.exports